export default "__VITE_ASSET__BwU71wTF__"